// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1vuPm","notes":"Notes_notes__14Umg","note":"Notes_note__kzmmQ","markdown":"Notes_markdown__39epf"};